import * as React from "react";
import { MemoriaBase } from "./MemoriaBase";
import { NFSE_CONFIG } from "./memoriaConfigs";

export const MemoriaNfse = () => <MemoriaBase config={NFSE_CONFIG} />;

export default MemoriaNfse;
